
export interface WithdrawalOrder {
  id: ID;
  account_id: ID;
  currency: Currency;
  amount: number;
  status: WithdrawalOrderStatus;
  created_at: number;
  wallet_address: string | null;
  is_cancelable: boolean;
}

export enum WithdrawalOrderStatus {
  unknown = 0,
  waiting = 1,
  processing = 2,
  successfully = 3,
  rejected = 4,
  canceled = 5,
}
